<template>
  <el-popover placement="right-end" @show="popoverShow" trigger="hover" width="800" height="520">
    <el-table :data="pagingList"
              v-loading="tableLoading"
              max-height="500px"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
              border
              size="mini"
              :span-method="cellMerge">
      <el-table-column label="货物类型"
                       prop="productTypeFirstName"
                       align="center"
                       width="100px"></el-table-column>
      <el-table-column label="产品类型"
                       prop="productTpeSecondaryName"
                       align="center"
                       width="150px"></el-table-column>
      <el-table-column label="产品品名" align="center" min-width="300px">
        <template slot-scope="scope">
          <template v-if="scope.row.productList.length<=50">
            <el-tooltip :content="scope.row.productList.join(',')" placement="top" popper-class="cus-popper">
              <div class="product-name-overflow">
                {{ scope.row.productList.join(',') }}
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <zip-code-list
              :list="scope.row.productList"
            />
          </template>

<!--          <el-tooltip :content="scope.row.productList.join(',')" placement="top" popper-class="cus-popper">-->
<!--            <div class="product-name-overflow">-->
<!--              {{ scope.row.productList.join(',') }}-->
<!--            </div>-->
<!--          </el-tooltip>-->
        </template>
      </el-table-column>
      <template v-if="countData.isProductSurcharge">
        <el-table-column label="附加费"
                       prop="price"
                       align="center"
                       width="70px"></el-table-column>
      <el-table-column label="币种"
                       prop="currency"
                       align="center"
                       width="70px"></el-table-column>
      </template>
    </el-table>
    <el-pagination
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      :total="list.length"
      style="text-align:right;"
    ></el-pagination>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
import ZipCodeList from "@/components/placeOrder/components/zipCodeRegionSearch/zipCodeList";
export default {
  name: "index",
  components: {ZipCodeList},
  props: {
    tableData: {
      type: Array,
      default: []
    },
    tableLoading: false,
    countData: {
			type: Object,
			default: () => {}
		}
  },
  data() {
    return {
      productTypeFirstNameLength: [],
      pageSize: 5,
      currentPage: 1
    }
  },
  // watch: {
  //   tableData: {
  //     immediate: true,
  //     handler(val) {
  //       this.dataFormat(val)
  //     }
  //   }
  // },
  computed: {
    list() {
      return this.dataFormat(this.tableData)
    },
    pagingList() {
      return this.list.slice(this.pageSize*(this.currentPage-1), this.pageSize*this.currentPage)
    }
  },
  methods: {
    popoverShow() {
      this.$emit('show')
    },
    dataFormat(arr) {
      let tableData = []
      arr.forEach(v => {
        let o
        if (v.productTpeSecondaryNameList && v.productTpeSecondaryNameList.length) {
          v.productTpeSecondaryNameList.forEach(u => {
            o = {
              ...v,
              currency: u.currency,
              price: u.price,
              productTpeSecondaryName: u.productTpeSecondaryName,
              productList: u.productList.map(item => item.productName)
            }
          })
        } else {
          o = {
            ...v,
            currency: '',
            price: '',
            productTpeSecondaryName: '',
            productList: []
          }
        }
        tableData.push(o)
      })
      this.getSpanArr(tableData)
      return tableData
    },
    cellMerge({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4) {
      if (columnIndex === 0) {
        const o = this.productTypeFirstNameLength[rowIndex]
        if (o.isFirst) {
          return {
            rowspan: o.length === 0 ? 1 : o.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getSpanArr(data) {
      this.productTypeFirstNameLength = []
      data.forEach((item, index) => {
        if(index === data.findIndex(v => {
          return v.productTypeFirstName === item.productTypeFirstName
        })) {
          this.productTypeFirstNameLength.push({
            name: item.productTypeFirstName,
            length: item.productTpeSecondaryNameList.length,
            isFirst: true
          })
        } else {
          this.productTypeFirstNameLength.push({
            name: item.productTypeFirstName,
            length: item.productTpeSecondaryNameList.length,
            isFirst: false
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/goodsDetailList.vue